import { create } from 'zustand';
import { allSlices } from './interface';
import createChatSlice from './chatSlice';
import createBoardSlice from './boardSlice';
import createToolSlice from './toolSlice';
import createRoomSlice from './roomSlice';
import createAgoraSlice from './agoraSlice';
import createPollSlice from './pollSlice';
import createBytePlusSlice from './bytePluseSlice';
import createWhiteboardSlice from './whiteBoardSlice';
import createQnaSlice from './qnaSlice';

const useStore = create<allSlices>()((...args) => ({
  chat: createChatSlice(...args),
  board: createBoardSlice(...args),
  tools: createToolSlice(...args),
  room: createRoomSlice(...args),
  agora: createAgoraSlice(...args),
  poll: createPollSlice(...args),
  byteplus: createBytePlusSlice(...args),
  whiteboard: createWhiteboardSlice(...args),
  qna: createQnaSlice(...args)
}));

export default useStore;
